import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_MONITOR_LIST } from "@assets/svgs/ICON_MONITOR_LIST.svg";
import { Text } from "@components/Text";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
`;

const ContainerContent = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  overflow: scroll;
`;

const ContainerItem = styled.div`
  position: relative;
  display: flex;
  border-radius: 16px;
  border: 1px solid #eee;
  justify-content: center;
  align-items: center;
  padding: 12px 8px;
  background: transparent;
`;

const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 28px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background: #eee;
  margin-bottom: 12px;
`;
export const DeviceList = ({ data }) => {
  return (
    <Container>
      <Line />
      <ContainerContent>
        {_.map(data, (item, index) => {
          return (
            <ContainerItem key={index}>
              <ContainerText>
                <Text
                  align="center"
                  color="black"
                  fontSize={"14px"}
                  fontWeight="600"
                >
                  Device
                </Text>
                <Text
                  lines={1}
                  isBreak={true}
                  isEllipsis
                  style={{ width: 90 }}
                  align="center"
                  color="black"
                  fontSize={"12px"}
                  fontWeight="500"
                >
                  {_.get(item, ["device", "name"])}
                </Text>
              </ContainerText>

              <ICON_MONITOR_LIST />
            </ContainerItem>
          );
        })}
      </ContainerContent>
    </Container>
  );
};
